import React from 'react';
import arrowRight from 'img/arrow-right-white.svg';
import {
  Button,
  Divider,
  InformationsItemsContainer,
  PanelArea,
  Title,
} from 'pages/lectures/styles';
import { informationsItemsArrayDifQuestions } from 'pages/lectures/utils';
import { InformationsItems } from 'pages/lectures/components/InformationsItems';
import { SubTitle } from 'pages/lectures/components/commons/styles';
import { PanelHeader } from 'pages/lectures/components/commons/styles';
import { LectureData } from 'pages/lectures/types';
import { DescriptionArea, LastMessageDescription, ListDescriptions } from './styles';

export function InstructionsDifQuestions({ handleStartLecture, lecture }: InformationsProps) {
  return (
    <PanelArea data-testid="instructions-panel-area">
      <PanelHeader>
        <Title width="fit-content" data-testid="instructions-title">
          {lecture?.titulo}
        </Title>
        <SubTitle data-testid="instructions-subtitle">
          Esta prova combina questões objetivas, dissertativas e de árvore de decisão, reproduzindo
          a experiência das avaliações oficiais da Anbima para que você possa se preparar com
          confiança.
        </SubTitle>
      </PanelHeader>
      <InformationsItemsContainer
        margin="12px 0 auto 0"
        data-testid="instructions-information-container"
      >
        {informationsItemsArrayDifQuestions.map((item, index) => {
          const title = item.title.replace(
            '%%questionsQuantities%%',
            lecture?.questions?.length.toString()
          );
          return (
            <div key={index} data-testid="instructions-information-item">
              <InformationsItems
                icon={item.icon}
                title={title}
                noIconBorder={true}
                description={item.description}
                imgWidth="30px"
              />
              <Divider />
            </div>
          );
        })}
        <DescriptionArea>
          <h4>Regras de pontuação</h4>
          <ListDescriptions>
            <li>Cada questão vale 1 ponto</li>
            <li>Para ser aprovado, o aluno deve acertar pelo menos 70% da prova</li>
            <li>
              Nas árvores de decisão, o aluno pode pontuar até 3 pontos por caso completo (1 pela
              navegação correta + 1 por cada decisão final correta)
            </li>
          </ListDescriptions>
        </DescriptionArea>
      </InformationsItemsContainer>
      <LastMessageDescription>
        Assim que clicar em “Começar a prova”, o tempo começa a contar. Você pode navegar entre as
        questões.
      </LastMessageDescription>
      <Button
        variant="primary"
        width="100%"
        onClick={handleStartLecture}
        data-testid="instructions-button-start-test"
      >
        Começar a prova
        <img src={arrowRight} alt="Começar" width={18} height={18} />
      </Button>
    </PanelArea>
  );
}

type InformationsProps = {
  lecture: LectureData;
  handleStartLecture: () => void;
};
